// These schemas must match their corresponding DB model in @performyard/models
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmbeddedWorkflowModel () {
        return EmbeddedWorkflowModel;
    },
    get LookupWorkflowModel () {
        return LookupWorkflowModel;
    },
    get ReviewCycleDetailsModel () {
        return ReviewCycleDetailsModel;
    },
    get ReviewCycleExternalFormModel () {
        return ReviewCycleExternalFormModel;
    },
    get ReviewCycleFormModel () {
        return ReviewCycleFormModel;
    },
    get ReviewCycleInternalFormModel () {
        return ReviewCycleInternalFormModel;
    },
    get ReviewCycleModel () {
        return ReviewCycleModel;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _autoflow = require("../autoflows/autoflow");
const SingleRelativeParticipant = _zod.z.enum([
    "self",
    "manager",
    "manager-manager",
    "other"
]);
const ReviewParticipant = _zod.z.union([
    _utilsisomorphic.transformObjectId,
    SingleRelativeParticipant,
    _zod.z.literal("contributors")
]);
const ReviewAuthorParticipant = _zod.z.union([
    ReviewParticipant,
    _zod.z.literal("direct-reports")
]);
const ExternalReviewAuthor = _zod.z.object({
    name: _zod.z.string(),
    email: _zod.z.string(),
    emailBody: _zod.z.string()
});
const ReviewCycleInternalFormModel = _zod.z.object({
    formId: _utilsisomorphic.transformObjectId,
    visible: _zod.z.boolean(),
    redacted: _zod.z.boolean(),
    authors: _zod.z.array(ReviewAuthorParticipant).optional(),
    signers: _zod.z.array(ReviewParticipant).optional(),
    external: _zod.z.literal(false),
    authorsDueDate: _utilsisomorphic.transformDate.nullable().optional(),
    signersDueDate: _utilsisomorphic.transformDate.nullable().optional(),
    author: ReviewAuthorParticipant.nullable().optional(),
    signer: ReviewParticipant.nullable().optional(),
    daysToCompleteAuthors: _zod.z.number().optional(),
    daysToCompleteSigners: _zod.z.number().optional(),
    authorObjects: _zod.z.array(_zod.z.object({})).optional(),
    completer: _zod.z.string().optional(),
    daysToComplete: _zod.z.number().optional()
});
const ReviewCycleExternalFormModel = ReviewCycleInternalFormModel.extend({
    authors: _zod.z.array(ExternalReviewAuthor).optional(),
    external: _zod.z.literal(true),
    author: ExternalReviewAuthor.nullable().optional()
});
const ReviewCycleFormModel = _zod.z.discriminatedUnion("external", [
    ReviewCycleInternalFormModel,
    ReviewCycleExternalFormModel
]);
const EmbeddedWorkflowModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    forms: _zod.z.array(ReviewCycleFormModel),
    company: _utilsisomorphic.transformObjectId,
    lastUpdate: _utilsisomorphic.transformDate.optional(),
    insensitiveName: _zod.z.string().optional()
});
const LookupWorkflowModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    company: _utilsisomorphic.transformObjectId,
    deletedAt: _utilsisomorphic.transformDate.optional()
});
const ReviewCycleModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    company: _utilsisomorphic.transformObjectId,
    creator: _utilsisomorphic.transformObjectId,
    subjects: _zod.z.array(_utilsisomorphic.transformObjectId),
    userSelection: _zod.z.array(_utilsisomorphic.transformObjectId).optional(),
    workflow: EmbeddedWorkflowModel,
    startDate: _utilsisomorphic.transformDate,
    adminsOnly: _zod.z.boolean().optional(),
    easyAddConfigs: _zod.z.array(_utilsisomorphic.transformObjectId.nullable()).optional(),
    groupId: _utilsisomorphic.transformObjectId.nullable().optional(),
    department: _utilsisomorphic.transformObjectId.nullable().optional(),
    participants: _zod.z.array(_utilsisomorphic.transformObjectId).optional(),
    reviews: _zod.z.array(_utilsisomorphic.transformObjectId).optional(),
    completedReviews: _zod.z.array(_utilsisomorphic.transformObjectId).optional(),
    unassignedReports: _zod.z.number(),
    completed: _zod.z.boolean().optional(),
    completeDate: _utilsisomorphic.transformDate.nullable().optional(),
    deleted: _zod.z.boolean().optional(),
    isClosing: _zod.z.boolean().optional(),
    unassignedCount: _zod.z.number().optional(),
    jobStatus: _models.ReviewCycleJobStatus.optional()
});
const ReviewCycleDetailsModel = _zod.z.object({
    name: _zod.z.string(),
    startDate: _utilsisomorphic.transformDate,
    dueDate: _utilsisomorphic.transformDate.nullable(),
    reviewCount: _zod.z.number(),
    type: _models.ReviewCycleType,
    status: _models.ReviewCycleStatus,
    autoflow: _autoflow.AutoflowModel.nullable(),
    groupName: _zod.z.string().nullable(),
    hasEasyAdds: _zod.z.boolean(),
    hasGoalDiscussion: _zod.z.boolean(),
    jobStatus: _models.ReviewCycleJobStatus.optional(),
    lookupWorkflow: LookupWorkflowModel.nullable()
});
